module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/design-subcategories/categories-list/categories-list.component.css
// module id = ./src/app/modules/dashboard/design-subcategories/categories-list/categories-list.component.css
// module chunks = dashboard.module